!<!--  -->
<template>
  <div class="" style="">
    <div
      class=""
      style="
        padding: 30px;
        background: #ffffff;
        box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
        border-radius: 10px;
      "
    >
      <span
        style="
          margin-bottom: 20px;
          width: 71px;
          height: 23px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #343434;
        "
        >发货人</span
      >

      <div
        style="
          width: 147px;
          height: 40px;
          background: #ffffff;
          margin: 30px 0 20px 0;
          border: 1px solid #FF4D01;
          border-radius: 5px;
          text-align: center;
        "
      >
        <span
          @click="dialogVisible = true"
          class="pointer"
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FF4D01;
            line-height: 40px;
          "
          >新增发货地址</span
        >
      </div>
      <!-- 地址卡片 -->
      <div>
        <el-card
          v-for="(item, index) in addrList"
          :key="index"
          class="box-card card-hover"
          style="margin-bottom: 20px; border-radius: 10px"
        >
          <div
            style="
              display: flex;

              justify-content: space-between;
              padding-right: 40px;
            "
          >
            <div style="">
              <!-- 行1 -->
              <div>
                <span
                  style="
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #343434;
                  "
                  >{{ item.name }}</span
                >
                <span
                  style="
                    margin-left: 20px;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #343434;
                  "
                  >{{ item.tel }}</span
                >
                <!-- <div
                  style="
                    margin-left: 20px;
                    display: inline-block;
                    height: 26px;
                    background: #e8efff;
                    border: 1px solid #FF4D01;
                    border-radius: 5px;
                  "
                 
                > -->
                <span
                  v-if="item.isDefault"
                  style="
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #FF4D01;
                    line-height: 26px;
                    padding: 0 8px 0 8px;
                  "
                  >默认地址</span
                >
                <!-- </div> -->
                <div
                  style="
                    display: inline-block;
                    height: 26px;
                    background: rgb(243 247 255);
                    border: 1px solid #FF4D01;
                    border-radius: 5px;
                  "
                  v-if="item.tag"
                >
                  <span
                    style="
                      font-size: 14px;
                      font-family: PingFang SC;
                      font-weight: 500;
                      color: #FF4D01;
                      line-height: 26px;
                      padding: 0 8px 0 8px;
                    "
                    >{{ item.tag }}</span
                  >
                </div>
              </div>

              <!-- 行2 -->
              <!-- <div style="margin-top: 20px">
                <span style="margin-right: 10px">{{ item.country }}</span>
                <span style="margin-right: 10px">{{ item.city }}</span>
                <span style="margin-right: 10px" v-if="item.area">{{
                  item.area
                }}</span>
                <span style="margin-right: 10px">{{ item.address }}</span>
              </div> -->
            </div>

            <div>
              <span
                @click="setAsDefault(item)"
                v-if="!item.isDefault"
                style="
                  border-right: 1px solid #FF4D01;
                  padding-right: 20px;
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #FF4D01;
                "
                class="pointer"
                >设为默认</span
              >
              <span
                @click="edit(item)"
                style="
                  border-right: 1px solid #FF4D01;
                  padding: 0 20px;
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #FF4D01;
                "
                class="pointer"
                >编辑</span
              >
              <span
                @click="confirmDelete(item.id)"
                style="color: #999; padding: 0 20px"
                class="pointer"
                >删除</span
              >
            </div>
          </div>
        </el-card>
      </div>

      <!-- 新增弹窗 -->
      <el-dialog
        :before-close="handleClose"
        custom-class="class1"
        style="border-radius: 20px"
        :title="this.submitForm.id ? '修改发货人地址' : '新增发货人地址'"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div style="width: 85%; margin: 0 auto; max-width: 500px">
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <span style="line-height: 40px">联系人</span>
              </div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple">
                <el-input
                  maxlength="20"
                  v-model="submitForm.consignee"
                  placeholder="请输入联系人(20个字符以内)"
                ></el-input></div
            ></el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <span style="line-height: 40px">联系方式</span>
              </div></el-col
            >
            <el-col :span="18">
              <div class="grid-content bg-purple">
                <el-input
                  v-model="submitForm.tel"
                  placeholder="请输入联系方式"
                ></el-input></div
            ></el-col>
          </el-row>
          <!-- <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <span style="line-height: 40px">联系地址</span>
              </div></el-col
            >
            <el-col :span="18">
              <div class="grid-content bg-purple">
                <el-cascader :options="citylist" placeholder="请选择收货地址"
                 v-model="value" clearable   @change="handleChange"
                 :props="props">
                </el-cascader>
              </div>
            </el-col>
          </el-row> -->

          <!-- <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <div
                  style="line-height: 40px; width: 10px; height: 10px"
                ></div></div
            ></el-col>
            <el-col :span="18"
              ><div class="grid-content bg-purple">
                <el-input v-model="submitForm.address"  type="textarea" rows="2" placeholder="请输入详细地址"></el-input></div
            ></el-col>
          </el-row> -->
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <span style="line-height: 40px">标签</span>
              </div></el-col
            >
            <el-col :span="18"
              ><div class="grid-content bg-purple">
                <el-input
                  v-model="submitForm.label"
                  placeholder="请输入标签"
                ></el-input></div
            ></el-col>
          </el-row>

          <div style="width: 300px; margin: 0 auto; text-align: center">
            <div style="display: flex; justify-content: center">
              <el-checkbox
                text-color="#FF4D01"
                v-model="submitForm.isdefaultaddress"
                style="margin-right: 10px"
              ></el-checkbox>
              <span style="display: block; margin-bottom: 20px">
                设置为默认地址
              </span>
            </div>
            <el-button
              @click="addAddr"
              style="
                background: #FF4D01;
                border: 1px solid #FF4D01;
                border-radius: 5px;
                color: #fff;
              "
              >{{ this.submitForm.id ? "修改" : "新增" }}</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      props: {
        value: "namec",
        label: "namec",
      },
      value: "",
      citylist: [], // 省市区列表
      submitForm: {
        address: "",
        area: "",
        city: "",
        consignee: "",
        contactype2: "S",
        country: "",
        customerid: "",
        isdefaultaddress: false,
        label: "",
        openid: "",
        parvince: "",
        tel: "",
        type: "I",
      },
      dialogVisible: false,
      addrList: [],
      value: ["", ""],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    setAsDefault(item) {
      this.submitForm.consignee = item.name;
      this.submitForm.country = item.country;
      this.submitForm.city = item.city;
      this.submitForm.area = item.area;
      this.submitForm.id = item.id;
      this.submitForm.tel = item.tel;
      //    this.submitForm.city = item.city
      this.submitForm.address = item.address;
      this.submitForm.label = item.tag;
      this.submitForm.isdefaultaddress = true;
      this.addAddr();
    },
    resetData() {
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
      this.submitForm.type = "I";
      this.submitForm.contactype2 = "S";
      this.submitForm.isdefaultaddress = false;
      console.log(this.value);

      console.log(this.value);
      this.value = ["", "", ""];
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.resetData();
    },
    // 修改赋值
    edit(item) {
      console.log(item);

      //    this.submitForm.country = item.country
      // this.value = []
      this.value = ["", "", ""];
      this.value[0] = item.country;
      this.value[1] = item.city;
      this.value[2] = item.area;
      console.log(this.value);
      this.submitForm.consignee = item.name;
      this.submitForm.country = item.country;
      this.submitForm.area = item.area;
      this.submitForm.city = item.city;
      this.submitForm.id = item.id;
      this.submitForm.tel = item.tel;
      //    this.submitForm.city = item.city
      this.submitForm.address = item.address;
      this.submitForm.label = item.tag;
      this.submitForm.isdefaultaddress = item.isDefault;

      this.dialogVisible = true;
    },
    // 获取省市区列表
    getPopList() {
      let user = this.sessionGetUserInfo();

      this.axios
        .post(
          "/filedata/filedataProvinces",
          {},
          {
            headers: {
              token: user.token,
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.citylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
    },
    // 级联选择器方法
    handleChange(value) {
      console.log(value);
      this.submitForm.country = value[0];
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
    },
    // 删除
    confirmDelete(id) {
      this.$confirm("此操作将删除该地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let user = this.sessionGetUserInfo();

          this.axios
            .post(
              "/customer/delAddress/" + id,
              {},
              {
                headers: {
                  token: user.token,
                },
              }
            )
            .then((res) => {
              if (res.data.code != 200) {
                this.$message("服务器繁忙");
                return;
              }
              this.$message("删除成功");
              this.getList();
            })
            .catch((res) => {
              this.$message("服务器繁忙");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    isPhone(num) {
      let mPattern = /^1[345678]\d{9}$/;
      return mPattern.test(num);
    },
    addAddr() {
      if (!this.submitForm.consignee) return this.$message.info("请输入联系人");
      if (!this.submitForm.tel) return this.$message.info("请输入联系方式");

      if (this.submitForm.consignee.substring(0, 1)>20) {
        this.$message.info("联系人不能超过20个字符！");
        return false;
      }
      if (this.submitForm.tel.substring(0, 1) == "1") { //验证手机
        if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.submitForm.tel)) {
          this.$message.info("格式错误，请输入正确的手机号");
          return false;
        }
      }else{//验证座机
        if([...this.submitForm.tel].length>13) return this.$message.info("格式错误，请输入正确的联系方式");
      }
      if (this.submitForm.label) {
        if (this.submitForm.label.length > 10) {
          this.$message.info("标签长度不能超过十个字符");
          return false;
        }
      }
      console.log(this.submitForm.id);
      if (this.submitForm.id) {
        this.submitForm.addressid = this.submitForm.id;
        this.submitForm.type = "U";
      } else {
        this.submitForm.type = "I";
      }

      let user = this.sessionGetUserInfo();
      // 新增
      this.submitForm.customerid = user.customerid;
      //   let username = uni.getStorageSync("userinformation").username; //手机号或者账号

      this.axios
        .post("/customer/addOrUpdateAddress", this.submitForm, {
          headers: {
            token: user.token,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.code != 200) {
            this.$message.info(res.data.message);
            return;
          }
          this.$message({
            message:this.submitForm.id ? "修改成功!" : "新增成功!",
            type: 'success'
          });

          this.getList();
          this.dialogVisible = false;
          this.resetData();
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getList() {
      let user = this.sessionGetUserInfo();

      this.axios
        .get("/customer/addressList/" + user.customerid + "/S", {
          headers: {
            token: user.token,
          },
        })
        .then((res) => {
          console.log(res);
          this.addList = res.datas;
          if (res.data.code != 200) {
            this.$message.info("服务器繁忙...");
            return;
          }
          this.addrList = res.data.datas.map((item, index) => {
            return {
              id: item.id,
              name: item.name,
              tel: item.tel,
              isDefault: item.isdefault,
              country: item.country,
              city: item.city,
              area: item.area,
              address: item.address,
              tag: item.tag,
            };
          });
          console.log(this.addrList);
        })
        .catch((res) => {
          console.log("falss");
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //   获取地址列表
    this.getList();
    // 获取目的国列表
    this.getPopList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style  scoped>
/* @import './../../../assets/css/free.css';
@import url('./../../../assets/css/free.css');  */
.card-hover:hover {
  border: 1px solid #FF4D01;
}
.class1 {
  border-radius: 20px;
}
.pointer {
  cursor: pointer;
}
/* //@import url(); 引入公共css类 */
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/personalInfo/SendPage.vue